export const BackButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={9.9} height={17}>
    <path fill="currentColor" d="M0 8.5 1.4 7l8.5 8.5L8.5 17z" />
    <path fill="currentColor" d="M1.4 9.9 0 8.5 8.5 0l1.4 1.4z" />
  </svg>
);
